import { useEffect, useRef, useCallback } from "react";
import style from "./main.module.css";
import walletStyles from "../wallet/wallet.module.css"; 
import { Icon } from "@iconify/react";
import wallet_icon from "../../assets/images/wallet.svg";
import bitcoinIcon from "../../assets/images/bitcoin.svg";
import ethIcon from "../../assets/images/ethereum-eth-logo.png";
import ltcIcon from "../../assets/images/litecoin-ltc-logo.svg";
import usdtIcon from "../../assets/images/tether-usdt-logo.svg";
import xrpIcon from "../../assets/images/xrp-xrp-logo.svg";
import dogeIcon from "../../assets/images/dogecoin-doge-logo.svg";
import trxIcon from "../../assets/images/tron-trx-logo.svg";
import bnbIcon from "../../assets/images/bnb-bnb-logo.svg";
import usdcIcon from "../../assets/images/usd-coin-usdc-logo.svg";
import solIcon from "../../assets/images/solana-sol-logo.svg";
import xlmIcon from "../../assets/images/stellar-xlm-logo.svg";
import moreIcon from "../../assets/images/element-3.svg";
import closeWhiteIcon from "../../assets/images/close-circle-white.svg";
import copy_icon from "../../assets/images/fluent_copy-white.svg";
import info_icon from "../../assets/images/info_icon.svg";
import moneyIcon from "../../assets/images/moneys.svg";
import arrow_left from "../../assets/images/arrow-left.svg";
import successIcon from "../../assets/images/check-mark.svg";
import spin_circle from "../../assets/images/Loader anim.png";
import { CardPos, Receive, Wallet3, ArrowDown2 } from "iconsax-react";
import "react-circular-progressbar/dist/styles.css";
import { Link, useNavigate } from "react-router-dom";
import WalletCard from "../wallet/WalletCard";
import { useDispatch, useSelector } from "react-redux";
import Lottie from "lottie-react";
import loader from "../../assets/lottie/loader.json";
import { useState } from "react";
import Modal from "../modal/Modal";
import cogoToast from "cogo-toast";
import PinInput from "react-pin-input";
import { setPin, getCryptoCoins } from "../../store/settings/settingsActions";
import { setHeader, setProfileImage } from "../../store/settings/settingsSlice";
import { getFiatCurrencies, getWalletBalance,fetchExchangeConfig, InitiateExchange } from "../../store/wallet/walletActions";
import { getKycStatusById } from "../../store/KYC/kycAction";
import { getAllCoins } from "../../store/crypto/cryptoActions";
import { createSwapTransaction, generateSwapQuotation, tradeCryptoToFiat, fiatToCrypto } from "../../store/crypto/cryptoActions";
import { browserName } from "react-device-detect";
import { getRecentTransactions } from "../../store/transactions/transActions";

const actions = [
  {
    id: 4,
    route: "/deposit",
    title: "Deposit",
    icon: <img src={wallet_icon} alt="Deposit" style={{width: '20px', height: '20px'}} />,
  },
  {
    id: 3,
    route: "/withdraw",
    title: "Withdraw",
    icon: <Receive size="20" color="#ffffff" variant="Outline" />,
  },
  {
    id: 5,
    route: null,
    title: "Buy/Sell",
    icon: <Wallet3 size="20" color="#ffffff" variant="Outline" />,
  },
  {
    id: 1,
    route: "/trade",
    title: "Giftcards",
    icon: <CardPos size="20" color="#ffffff" variant="Outline" />,
  },
  {
    id: 6,
    route: "/dashboard",
    title: "More",
    icon: <img src={moreIcon} alt="More" style={{width: '20px', height: '20px'}} />,
  },
];

const coinIcons = {
  BTC: bitcoinIcon,
  ETH: ethIcon,
  LTC: ltcIcon,
  USDT: usdtIcon,
  XRP: xrpIcon,
  DOGE: dogeIcon,
  TRX: trxIcon,
  BNB: bnbIcon,
  USDC: usdcIcon,
  SOL: solIcon,
  XLM: xlmIcon,
};

const TRANSACTION_TYPE_ENUM = {
  CRYPTO_TO_CRYPTO: "crypto_to_crypto",
  CRYPTO_TO_FIAT: "crypto_to_fiat",
  FIAT_TO_CRYPTO: "fiat_to_crypto",
};

const moreDrawerActions = [
  {
    label: "Buy/Sell",
    icon: <Icon icon="solar:cart-outline" fontSize={22} />,
    route: "/wallets",
  },
  {
    label: "Blogs",
    icon: <Icon icon="solar:book-outline" fontSize={22} />,
    route: "https://astroafrica.site/astro-blog/",
  },
  {
    label: "Virtual Cards",
    icon: <Icon icon="solar:card-outline" fontSize={22} />,
    route: "/virtual-cards",
  },
  {
    label: "Gift Cards",
    icon: <Icon icon="solar:gift-outline" fontSize={22} />,
    route: "/trade",
  },
  {
    label: "Prediqo",
    icon: <Icon icon="solar:chart-outline" fontSize={22} />,
    route: "/prediqo",
  },
  {
    label: "Referrals",
    icon: <Icon icon="solar:users-group-rounded-outline" fontSize={22} />,
    route: "/referrals",
  },
  {
    label: "Automated Payments",
    icon: <Icon icon="solar:document-outline" fontSize={22} />,
    route: "/settings",
  },
  {
    label: "Calculator",
    icon: <Icon icon="solar:calculator-outline" fontSize={22} />,
    route: "/calculator",
  },
  {
    label: "Transactions",
    icon: <Icon icon="solar:document-outline" fontSize={22} />,
    route: "/transactions",
  },
  {
    label: "Settings",
    icon: <Icon icon="solar:settings-outline" fontSize={22} />,
    route: "/settings",
  },
  {
    label: "Rate us",
    icon: <Icon icon="solar:star-outline" fontSize={22} />,
    route: "https://apps.apple.com/ng/app/astro-africa/id6447790674",
  },
];

const Main = ({ verifiedKYC, setNewRoute }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("all");
  const [totalTrades, setTotalTrades] = useState(0);
  const [totalTrans, setTotalTrans] = useState(0);
  const [isPin, setIsPin] = useState(false);
  const [pinNo, setPinNo] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [openPinModal, setOpenPinModal] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [showMoreDrawer, setShowMoreDrawer] = useState(false);

  // Swap Modal States
  const [isSwapModalOpen, setIsSwapModalOpen] = useState(false);
  const [isInstantSwapOpen, setIsInstantSwapOpen] = useState(false);
  const [fromCoin, setFromCoin] = useState(null);
  const [toCoin, setToCoin] = useState(null);
  const [swapAmount, setSwapAmount] = useState("");
  const [receiveAmount, setReceiveAmount] = useState("");
  const [openFromSelect, setOpenFromSelect] = useState(false);
  const [openToSelect, setOpenToSelect] = useState(false);
  const [swapType, setSwapType] = useState("CRYPTO_TO_CRYPTO");
  const [openSwapType, setOpenSwapType] = useState(false);
  const [swapTypeLabel, setSwapTypeLabel] = useState("Crypto to Crypto");
  const [isSwapInitiated, setIsSwapInitiated] = useState(false);
  const [isSwapLoading, setIsSwapLoading] = useState(false);
  const [isSuccessModal, setSuccessModal] = useState(false);
  const [isLoadingQuotation, setIsLoadingQuotation] = useState(false);
  const [quotationError, setQuotationError] = useState("");
  const [currentRate, setCurrentRate] = useState("");
  const [swapTimer, setSwapTimer] = useState(10);
  const [currencyExchangeSettingsId, setCurrencyExchangeSettingsId] = useState(null);


  const toSelectRef = useRef(null);
  const fromSelectRef = useRef(null);
  const swapTypeRef = useRef(null);
  const debounceRef = useRef(null);

  const swapTypeOptions = [
    { id: "CRYPTO_TO_CRYPTO", name: "Crypto to Crypto" },
    { id: "CRYPTO_TO_FIAT", name: "Crypto to Fiat" },
    { id: "FIAT_TO_CRYPTO", name: "Fiat to Crypto" },
    { id: "FIAT_TO_FIAT", name: "Fiat to Fiat" } 
  ];

  const userData = useSelector((state) => state.auth.user);
  const isAuth = useSelector((state) => state.auth.isAuthenticated);
  const coins = useSelector((state) => state.crypto.coins);
  const loading = useSelector((state) => state.crypto.loading);
  const walletData = useSelector((state) => state.wallet.data);
  const saveLoad = useSelector((state) => state.settings.saveLoading);
  const totalTransactions = useSelector((state) => state.trans.recentData.totalNumberOfTransaction);
  const allTrades = useSelector((state) => state.trans.recentData.numberOfCryptoTrade);
  const exchangeConfig = useSelector((state) => state.wallet.exchangeConfig);
  const isPinSet = useSelector((state) => state.auth.pinData);
  const username = useSelector(state => state.auth.fullUser.username);
  const { cryptocoins = [] } = useSelector((state) => state.settings);

  const getFiatIcon = (currencyCode) => {
    const flagIcons = {
      NGN: "https://flagcdn.com/ng.svg",
      GHS: "https://flagcdn.com/gh.svg",
      USD: "https://flagcdn.com/us.svg"
    };
    return flagIcons[currencyCode] || "https://flagcdn.com/un.svg";
  };

  const getQuidaxUserId = useCallback(() => {
    if (swapType === "FIAT_TO_CRYPTO") {
      const toCoinData = cryptocoins.find(
        coin => coin.currency?.toUpperCase() === toCoin?.symbol
      );
      return toCoinData?.quidaxUserId || null;
    } else {
      const fromCoinData = cryptocoins.find(
        coin => coin.currency?.toUpperCase() === fromCoin?.symbol
      );
      return fromCoinData?.quidaxUserId || null;
    }
  }, [cryptocoins, fromCoin?.symbol, toCoin?.symbol, swapType]);

 const getAvailableFromAssets = (swapType) => {
  if (swapType === "FIAT_TO_CRYPTO" || swapType === "FIAT_TO_FIAT") {
    if (!walletData?.fiatWallets) return [];
    return walletData.fiatWallets
      .filter(wallet => {
        // Only filter out USD for FIAT_TO_CRYPTO, not for FIAT_TO_FIAT
        if (swapType === "FIAT_TO_CRYPTO") {
          return wallet.is_active && wallet.Currency.code !== "USD";
        }
        return wallet.is_active;
      })
      .map(wallet => ({
        name: wallet.Currency.name,
        symbol: wallet.Currency.code,
        icon: getFiatIcon(wallet.Currency.code),
        balance: wallet.balance || "0.00",
        id: wallet.id
      }));
  } else {
    return cryptocoins.map(coin => ({
      name: coin.name,
      symbol: coin.currency?.toUpperCase(),
      icon: coinIcons[coin.currency?.toUpperCase()] || bitcoinIcon,
      balance: coin.balance || "0.00",
      id: coin.coin_type_id
    }));
  }
};

 const getAvailableToAssets = (swapType) => {
  if (swapType === "CRYPTO_TO_CRYPTO") {
    return cryptocoins
      .filter(coin => coin.currency?.toUpperCase() !== fromCoin?.symbol)
      .map(coin => ({
        name: coin.name,
        symbol: coin.currency?.toUpperCase(),
        icon: coinIcons[coin.currency?.toUpperCase()] || bitcoinIcon,
        balance: coin.balance || "0.00",
        id: coin.coin_type_id
      }));
  } else if (swapType === "FIAT_TO_CRYPTO") {
    return cryptocoins.map(coin => ({
      name: coin.name,
      symbol: coin.currency?.toUpperCase(),
      icon: coinIcons[coin.currency?.toUpperCase()] || bitcoinIcon,
      balance: coin.balance || "0.00",
      id: coin.coin_type_id
    }));
  } else if (swapType === "FIAT_TO_FIAT") { 
    if (!walletData?.fiatWallets) return [];
    return walletData.fiatWallets
      .filter(wallet => wallet.is_active && wallet.Currency.code !== fromCoin?.symbol)
      .map(wallet => ({
        name: wallet.Currency.name,
        symbol: wallet.Currency.code,
        icon: getFiatIcon(wallet.Currency.code),
        balance: wallet.balance || "0.00",
        id: wallet.id
      }));
  } else {
    // CRYPTO_TO_FIAT
    if (!walletData?.fiatWallets) return [];
    return walletData.fiatWallets
      .filter(wallet => wallet.is_active)
      .map(wallet => ({
        name: wallet.Currency.name,
        symbol: wallet.Currency.code,
        icon: getFiatIcon(wallet.Currency.code),
        balance: wallet.balance || "0.00",
        id: wallet.id
      }));
  }
};

  const resetSelections = (newSwapType) => {
    setFromCoin(null);
    setToCoin(null);
    setSwapAmount("");
    setReceiveAmount("");
    setCurrentRate("");
    setQuotationError("");
    setCurrencyExchangeSettingsId(null);  // NEW

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
  };

  const handleSwapType = (e, typeId) => {
    setOpenSwapType(false);
    setSwapTypeLabel(e.target.textContent);
    setSwapType(typeId);
    resetSelections(typeId);
  };

const handleSwapQuotation = useCallback(async (amount) => {
  if (!amount || !toCoin || !fromCoin || parseFloat(amount) <= 0) {
    setReceiveAmount("");
    setCurrentRate("");
    return;
  }

  // Handle Fiat to Fiat using exchangeConfig (no API call needed)
  if (swapType === "FIAT_TO_FIAT") {
    const exchangeRateData = exchangeConfig.find(
      (rate) =>
        rate.BaseCurrency.code === fromCoin.symbol && 
        rate.TargetCurrency.code === toCoin.symbol
    );

    if (exchangeRateData) {
      const rate = parseFloat(exchangeRateData.exchange_rate);
      const calculatedReceiveAmount = parseFloat(amount) * rate;
      setReceiveAmount(calculatedReceiveAmount.toFixed(2));
      setCurrencyExchangeSettingsId(exchangeRateData.id);
      
      // Format rate display (handle rates < 1)
      if (rate < 1) {
        const inverseRate = (1 / rate).toFixed(2);
        setCurrentRate(`1 ${toCoin.symbol} = ${inverseRate} ${fromCoin.symbol}`);
      } else {
        setCurrentRate(`1 ${fromCoin.symbol} = ${rate.toFixed(2)} ${toCoin.symbol}`);
      }
      setQuotationError("");
    } else {
      setQuotationError("Exchange rate not found for the selected currencies.");
      setReceiveAmount("");
      setCurrentRate("");
      setCurrencyExchangeSettingsId(null);
    }
    return;
  }

  // Existing logic for crypto swaps
  const quidaxUserId = getQuidaxUserId();
  if (!quidaxUserId) {
    setQuotationError("Unable to get wallet information");
    return;
  }

  setIsLoadingQuotation(true);
  setQuotationError("");

  const quotationData = {
    from_currency: fromCoin.symbol.toLowerCase(),
    to_currency: toCoin.symbol.toLowerCase(),
    from_amount: amount,
    quidaxUserId: quidaxUserId,
    transaction_type: TRANSACTION_TYPE_ENUM[swapType]
  };

  try {
    const result = await dispatch(generateSwapQuotation(quotationData));
    if (result.type === "generateSwapQuotation/fulfilled") {
      const quotation = result.payload;

      if (swapType === "CRYPTO_TO_CRYPTO") {
        const finalAmount = quotation.data?.final_amount;
        const quotedPrice = quotation.data?.quoted_price;
        setReceiveAmount(finalAmount);
        setCurrentRate(`1 ${fromCoin.symbol} = ${parseFloat(quotedPrice).toLocaleString(undefined, { maximumFractionDigits: 8 })} ${toCoin.symbol}`);
      } else {
        const rate = quotation.data?.rate;
        const finalPayout = quotation.data?.final_payout;
        setReceiveAmount(finalPayout);
        setCurrentRate(`1 ${fromCoin.symbol} = ${parseFloat(rate).toLocaleString(undefined, { maximumFractionDigits: 8 })} ${toCoin.symbol}`);
      }
    } else {
      setQuotationError("Failed to get swap quotation");
      setReceiveAmount("");
      setCurrentRate("");
    }
  } catch (error) {
    console.error("Quotation error:", error);
    setQuotationError("Failed to get swap quotation");
    setReceiveAmount("");
    setCurrentRate("");
  } finally {
    setIsLoadingQuotation(false);
  }
}, [dispatch, fromCoin, toCoin, getQuidaxUserId, swapType, exchangeConfig]);

  const debouncedQuotation = useCallback((amount) => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      handleSwapQuotation(amount);
    }, 800);
  }, [handleSwapQuotation]);

  const handleFinalSwap = async () => {
    setIsSwapInitiated(false);
    setIsInstantSwapOpen(false);
    setIsSwapLoading(true);

    try {
      let result;
      if (swapType === "CRYPTO_TO_CRYPTO") {
        const quidaxUserId = getQuidaxUserId();
        const swapData = {
          from_currency: fromCoin.symbol.toLowerCase(),
          to_currency: toCoin.symbol.toLowerCase(),
          from_amount: swapAmount,
          quidaxUserId: quidaxUserId
        };
        result = await dispatch(createSwapTransaction(swapData));
      } else if (swapType === "CRYPTO_TO_FIAT") {
        const tradeData = {
        coinTypeId: fromCoin.id,
        amount: swapAmount,
        rate: parseFloat(currentRate.split("=")[1]),
        payoutAmount: receiveAmount,
        creditWalletId: toCoin.id,
        coinAmount: swapAmount,
        sellerRemarks: ""
      };
      result = await dispatch(tradeCryptoToFiat(tradeData));
      } else if (swapType === "FIAT_TO_CRYPTO") {
        const fiatToCryptoData = {
          coinTypeId: toCoin.id,
          debitWalletId: fromCoin.id,
          amountFiat: swapAmount
        };
        result = await dispatch(fiatToCrypto(fiatToCryptoData));
      } else if (swapType === "FIAT_TO_FIAT") {  // NEW
        result = await dispatch(InitiateExchange({
          amount: parseFloat(swapAmount),
          currencyExchangeSettingsId: currencyExchangeSettingsId
        }));
      }

      if (result && result.type?.endsWith("/fulfilled")) {
        setIsSwapLoading(false);
        setSuccessModal(true);
        setSwapAmount("");
        setReceiveAmount("");
        setCurrentRate("");
        setFromCoin(null);
        setToCoin(null);
        setSwapType("CRYPTO_TO_CRYPTO");
        setSwapTypeLabel("Crypto to Crypto");
        setCurrencyExchangeSettingsId(null);  // NEW
        dispatch(getCryptoCoins());
        dispatch(getWalletBalance());
      } else {
        setIsSwapLoading(false);
        setSwapAmount("");
        setReceiveAmount("");
        setCurrentRate("");
        setFromCoin(null);
          setToCoin(null);
          setSwapType("CRYPTO_TO_CRYPTO");
          setSwapTypeLabel("Crypto to Crypto");
          setCurrencyExchangeSettingsId(null);  // NEW
        }
      } catch (error) {
        setIsSwapLoading(false);
        setSwapAmount("");
        setReceiveAmount("");
        setCurrentRate("");
        setFromCoin(null);
        setToCoin(null);
        setSwapType("CRYPTO_TO_CRYPTO");
        setSwapTypeLabel("Crypto to Crypto");
        setCurrencyExchangeSettingsId(null);  // NEW
        console.error("Swap error:", error);
      }
  };

  const handleInstantSwap = () => {
    setIsSwapModalOpen(false);
    setIsInstantSwapOpen(true);
  };

  const handleFromAssetSelect = (asset) => {
    setFromCoin(asset);
    setOpenFromSelect(false);
    setSwapAmount("");
    setReceiveAmount("");
    setCurrentRate("");
    setToCoin(null);
  };

  const handleToAssetSelect = (asset) => {
    setToCoin(asset);
    setOpenToSelect(false);
    if (swapAmount && parseFloat(swapAmount) > 0 && fromCoin) {
      setReceiveAmount("");
      setCurrentRate("");
      debouncedQuotation(swapAmount);
    }
  };

  const handleBuySellClick = () => {
    setIsSwapModalOpen(true);
  };

  function getGreeting() {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning";
    if (hour < 17) return "Good Afternoon";
    return "Good Evening";
  }

  const copyAstroTag = () => {
    navigator.clipboard.writeText(username);
    cogoToast.success("AstroTag copied to clipboard", {
      position: "top-right"
    });
  };

  const mappedTokens = (coins || []).map((coin) => ({
    id: coin.id,
    name: coin.name?.trim(),
    symbol: coin.code,
    icon: coinIcons[coin.code] || bitcoinIcon,
    price: coin.usd_rate
      ? `$${parseFloat(coin.usd_rate).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`
      : "$0.00",
    change: coin.price_change_percentage
      ? `${coin.price_change_percentage > 0 ? "+" : ""}${coin.price_change_percentage.toFixed(2)}%`
      : "0.00%",
    changeUp: coin.price_change_percentage > 0,
  }));

  const handleSetPin = () => {
    dispatch(setPin({ pinNo }));
  };

  // Click outside handlers
  useEffect(() => {
    function handleClickOutside(event) {
      if (toSelectRef.current && !toSelectRef.current.contains(event.target)) {
        setOpenToSelect(false);
      }
      if (fromSelectRef.current && !fromSelectRef.current.contains(event.target)) {
        setOpenFromSelect(false);
      }
      if (swapTypeRef.current && !swapTypeRef.current.contains(event.target)) {
        setOpenSwapType(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Timer for swap confirmation
  useEffect(() => {
    if (isSwapInitiated) {
      setSwapTimer(10);
      const interval = setInterval(() => {
        setSwapTimer(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [isSwapInitiated]);

  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);

  useEffect(() => {
    dispatch(setHeader("Dashboard"));
    dispatch(getFiatCurrencies());
    dispatch(getKycStatusById());
    dispatch(getCryptoCoins());
    dispatch(getRecentTransactions());
    dispatch(getWalletBalance());
    dispatch(fetchExchangeConfig());  // NEW - Fetch exchange config for Fiat to Fiat rates
}, [dispatch]);

  useEffect(() => {
    dispatch(getAllCoins());
  }, [isAuth, dispatch]);

  useEffect(() => {
    if (isAuth === false) {
      navigate("/");
    }
  }, [isAuth, navigate]);

  useEffect(() => {
    if (isPinSet.isSetPin === true) {
      setIsPin(true);
    } else {
      setIsPin(false);
    }

    if (saveLoad === true) {
      setSaveLoader(true);
    } else {
      setSaveLoader(false);
    }

    if (isPinSet.isSetPin === true) {
      setOpenPinModal(false);
    } else {
      setOpenPinModal(true);
    }
  }, [isPin, saveLoad, isPinSet]);

  useEffect(() => {
    if (userData.image_url !== null) {
      dispatch(setProfileImage(userData.image_url));
    }
  }, [userData.image_url, dispatch]);

  useEffect(() => {
    setTotalTrades(allTrades);
    setTotalTrans(totalTransactions);
  }, [allTrades, totalTransactions]);

  useEffect(() => {
    if (pinNo !== "" && pinNo.length === 5) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [pinNo]);

  return (
    <div className={style.main}>
      {/* Set PIN Modal */}
      <Modal modalOpen={openPinModal}>
        <div className={style.setYourPin}>
          <h2>Set Transaction Pin</h2>
          <p>
            Please set your transation PIN which will enable you to make
            transactions on Astro
          </p>
          <div className={style.inputs}>
            <PinInput
              length={5}
              initialValue=""
              secret={true}
              onChange={(value, index) => {
                setPinNo(value);
              }}
              type="numeric"
              inputMode="number"
              style={{ padding: "10px", margin: "0 auto 0 auto" }}
              inputStyle={{ border: "1px solid", borderColor: "#909090" }}
              inputFocusStyle={{ border: "2px solid", borderColor: "#40196D" }}
              onComplete={(value, index) => {
                setPinNo(value);
              }}
              autoSelect={true}
              regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
            />
          </div>
          {saveLoader === true ? (
            <div className={style.lottieWrap}>
              <Lottie
                style={{
                  width: "70px",
                  height: "70px",
                  color: "#fff",
                  padding: "0px",
                  margin: "0px",
                }}
                animationData={loader}
                loop={true}
              />
            </div>
          ) : (
            <button
              onClick={handleSetPin}
              disabled={isDisabled}
              className={style.save}
            >
              Set Transaction Pin
            </button>
          )}
        </div>
      </Modal>

      {/* Swap Options Modal */}
      <Modal
        title="Buy/Sell Crypto"
        minWidth="40%"
        canClose
        modalOpen={isSwapModalOpen}
        setModalOpen={setIsSwapModalOpen}
      >
        <div className={walletStyles.swapDisclaimer} style={{ marginTop: 0, marginBottom: '20px' }}>
          Buy or sell crypto instantly at<br />current market price
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <div 
            className={walletStyles.swapSelectBox}
            onClick={handleInstantSwap}
            style={{ cursor: 'pointer' }}
          >
            <div className={walletStyles.swapCoinBadge}>
              <div style={{
                width: '48px',
                height: '48px',
                background: '#40196D1A',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path d="M7 17l-4-4 4-4M17 8l4 4-4 4" stroke="#40196D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div>
                <div className={walletStyles.swapCoinSymbol}>Instant Swap</div>
                <div style={{ fontSize: '12px', color: '#909090', fontWeight: 400 }}>Swap any two assets instantly<br />(Fiat and Crypto)</div>
              </div>
            </div>
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path d="M9 18l6-6-6-6" stroke="#40196D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div 
            className={walletStyles.swapSelectBox}
            onClick={() => {
              setIsSwapModalOpen(false);
              navigate('/order-book?currency=BTC');
            }}
            style={{ cursor: 'pointer' }}
          >
            <div className={walletStyles.swapCoinBadge}>
              <div style={{
                width: '48px',
                height: '48px',
                background: '#40196D1A',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <svg width="28" height="28" fill="none" viewBox="0 0 24 24">
                  <rect x="4" y="4" width="16" height="16" rx="3" stroke="#40196D" strokeWidth="1.5"/>
                  <path d="M8 8h8M8 12h8M8 16h4" stroke="#40196D" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </div>
              <div>
                <div className={walletStyles.swapCoinSymbol}>Order Book</div>
                <div style={{ fontSize: '12px', color: '#909090', fontWeight: 400 }}>Buy or sell crypto on your terms.</div>
              </div>
            </div>
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path d="M9 18l6-6-6-6" stroke="#40196D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
      </Modal>

      {/* Instant Swap Modal */}
      <Modal
        title="Instant Swap"
        minWidth="40%"
        canClose
        modalOpen={isInstantSwapOpen}
        setModalOpen={setIsInstantSwapOpen}
      >
        {!isSwapInitiated ? (
          <form className={walletStyles.swapForm}>
            {/* SWAP TYPE SELECTOR */}
            <div className={walletStyles.labelPut}>
              <label>Swap Type</label>
              <div className={walletStyles.select} style={{marginTop: '10px'}} ref={swapTypeRef}>
                <div 
                  className={walletStyles.selectInput}
                  onClick={() => setOpenSwapType((prev) => !prev)}
                >
                  <input
                    type="text"
                    disabled={browserName === "Firefox" ? false : true}
                    value={swapTypeLabel}
                    placeholder="Select Swap Type"
                    style={{pointerEvents: "none"}}
                  />
                  <ArrowDown2
                    style={{
                      transform: openSwapType ? "translateY(-50%) rotate(-540deg)" : "translateY(-50%) rotate(0deg)",
                      pointerEvents: "none",
                    }}
                    className={walletStyles.dropDown}
                    size="20"
                    color="#909090"
                    variant="Bold"
                  />
                </div>
                <div
                  style={{
                    height: openSwapType ? "fit-content" : "0px",
                    maxHeight: 'fit-content',
                  }}
                  className={walletStyles.option}
                >
                  {swapTypeOptions.map((option, index) => (
                    <p
                      key={option.id}
                      onClick={(e) => handleSwapType(e, option.id)}
                      style={{
                        borderBottom: `${index !== swapTypeOptions.length - 1 ? '1px #90909042 solid': ''}`,
                        padding: '12px 16px',
                        margin: 0
                      }}
                    >
                      {option.name}
                    </p>
                  ))}
                </div>
              </div>
            </div>

            {/* FROM - Now always selectable */}
            <div className={walletStyles.labelPut} style={{marginTop: '12px'}}>
              <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <label>From</label>
                {fromCoin && (
                  <p style={{margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14}}>
                    Balance: {fromCoin.balance} {fromCoin.symbol}
                  </p>
                )}
              </div>
              <div className={walletStyles.select} style={{marginTop: '10px'}} ref={fromSelectRef}>
                <div
                  className={walletStyles.selectInput}
                  onClick={() => setOpenFromSelect((prev) => !prev)}
                >
                  <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    {fromCoin ? (
                      <>
                        <img src={fromCoin.icon} alt={fromCoin.symbol} className={walletStyles.swapCoinIcon} />
                        <span className={walletStyles.swapCoinSymbol}>{fromCoin.symbol}</span>
                      </>
                    ) : (
                      <span style={{color: '#909090'}}>
                        Select {swapType === "FIAT_TO_CRYPTO" || swapType === "FIAT_TO_FIAT" ? "Fiat" : "Crypto"}
                      </span>
                    )}
                  </div>
                  <ArrowDown2
                    style={{
                      transform: openFromSelect ? "translateY(-50%) rotate(-540deg)" : "translateY(-50%) rotate(0deg)",
                      pointerEvents: "none",
                    }}
                    className={walletStyles.dropDown}
                    size="20"
                    color="#909090"
                    variant="Bold"
                  />
                </div>
                <div
                  style={{
                    height: openFromSelect ? "fit-content" : "0px",
                    maxHeight: openFromSelect ? "200px" : "0px",
                    overflowY: "auto"
                  }}
                  className={walletStyles.option}
                >
                  {getAvailableFromAssets(swapType).map((asset, index) => (
                    <p
                      key={asset.symbol}
                      onClick={() => handleFromAssetSelect(asset)}
                      style={{
                        borderBottom: `${index !== getAvailableFromAssets(swapType).length - 1 ? '1px #90909042 solid': ''}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '10px',
                        padding: '12px 16px'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <img src={asset.icon} alt={asset.symbol} className={walletStyles.swapCoinIcon} />
                        <span>{asset.symbol} - {asset.name}</span>
                      </div>
                      <span style={{ fontSize: '12px', color: '#909090' }}>
                        {parseFloat(asset.balance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 8 })} {asset.symbol}
                      </span>
                    </p>
                  ))}
                </div>
              </div>
            </div>

            {/* AMOUNT */}
            <div className={walletStyles.labelPut} style={{marginTop: '10px'}}>
              <label>Amount<span style={{ color: "#FF0000" }}>*</span></label>
              <div className={walletStyles.input} style={{position: 'relative', marginTop: '10px'}}>
                <input
                  type="number"
                  name="swapAmount"
                  placeholder="Enter Swap Amount"
                  value={swapAmount}
                  disabled={!fromCoin}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (swapType === "FIAT_TO_CRYPTO" && (value === "" || parseFloat(value) <= 1)) {
                      setSwapAmount("");
                      setReceiveAmount("");
                      setCurrentRate("");
                      return;
                    }
                    setSwapAmount(value);
                    setReceiveAmount("");
                    setCurrentRate("");
                    if (toCoin && value && parseFloat(value) > 0) {
                      debouncedQuotation(value);
                    }
                  }}
                />
                {fromCoin && (
                  <div style={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    display: 'flex',
                    gap: '8px'
                  }}>
                    {['25%', '50%', '75%', 'Max'].map((percent) => (
                      <button
                        key={percent}
                        type="button"
                        style={{
                          background: '#f5f5f5',
                          border: 'none',
                          borderRadius: '4px',
                          padding: '4px 8px',
                          fontSize: '11px',
                          color: '#666',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          const balance = parseFloat(fromCoin.balance || 0);
                          let amount;
                          if (percent === 'Max') {
                            amount = balance.toString();
                          } else {
                            const percentage = parseInt(percent) / 100;
                            amount = (balance * percentage).toFixed(6);
                          }
                          setSwapAmount(amount);
                          setReceiveAmount("");
                          setCurrentRate("");
                          if (toCoin && amount && parseFloat(amount) > 0) {
                            handleSwapQuotation(amount);
                          }
                        }}
                      >
                        {percent}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* TO */}
            <div className={walletStyles.labelPut} style={{marginTop: '10px'}}>
              <label>To</label>
              <div className={walletStyles.select} style={{marginTop: '10px'}} ref={toSelectRef}>
                <div
                  className={walletStyles.selectInput}
                  onClick={() => fromCoin && setOpenToSelect((prev) => !prev)}
                  style={{ cursor: fromCoin ? 'pointer' : 'not-allowed', opacity: fromCoin ? 1 : 0.6 }}
                >
                  <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    {toCoin ? (
                      <>
                        <img src={toCoin.icon} alt={toCoin.symbol} className={walletStyles.swapCoinIcon} />
                        <span className={walletStyles.swapCoinSymbol}>{toCoin.symbol}</span>
                      </>
                    ) : (
                      <span style={{color: '#909090'}}>
                       {fromCoin ? `Select ${swapType === "CRYPTO_TO_FIAT" || swapType === "FIAT_TO_FIAT" ? "Fiat" : "Crypto"}` : "Select From first"}
                      </span>
                    )}
                  </div>
                  <ArrowDown2
                    style={{
                      transform: openToSelect ? "translateY(-50%) rotate(-540deg)" : "translateY(-50%) rotate(0deg)",
                      pointerEvents: "none",
                    }}
                    className={walletStyles.dropDown}
                    size="20"
                    color="#909090"
                    variant="Bold"
                  />
                </div>
                <div
                  style={{
                    height: openToSelect ? "fit-content" : "0px",
                    maxHeight: openToSelect ? "200px" : "0px",
                    overflowY: "auto"
                  }}
                  className={walletStyles.option}
                >
                  {getAvailableToAssets(swapType).length > 0 ? (
                    getAvailableToAssets(swapType).map((asset, index) => (
                      <p
                        key={asset.symbol}
                        onClick={() => handleToAssetSelect(asset)}
                        style={{
                          borderBottom: `${index !== getAvailableToAssets(swapType).length - 1 ? '1px #90909042 solid': ''}`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: '10px',
                          padding: '12px 16px'
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <img src={asset.icon} alt={asset.symbol} className={walletStyles.swapCoinIcon} />
                          <span>{asset.symbol} - {asset.name}</span>
                        </div>
                        <span style={{ fontSize: '12px', color: '#909090' }}>
                            {parseFloat(asset.balance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 8 })} {asset.symbol}
                        </span>
                      </p>
                    ))
                  ) : (
                    <p style={{ padding: '12px 16px', color: '#FF0000' }}>
                      {swapType === "CRYPTO_TO_CRYPTO"
                        ? "No available cryptocurrencies to swap to."
                        : "No fiat wallets available."}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Rate Info */}
            <div className={walletStyles.swapRateInfo}>
              <img src={info_icon} alt="info" style={{ width: 18, height: 18, marginRight: 6 }} />
              {isLoadingQuotation ? (
                "Getting current rate..."
              ) : quotationError ? (
                <span style={{ color: '#F40000' }}>{quotationError}</span>
              ) : currentRate ? (
                currentRate
              ) : (
                "Enter amount to see rate"
              )}
            </div>

            {/* You Receive */}
            <div className={walletStyles.labelPut} style={{marginTop: '10px'}}>
              <label>You Receive</label>
              <div className={walletStyles.input} style={{marginTop: '10px'}}>
                <input
                  type="text"
                  name="receiveAmount"
                  placeholder="Amount"
                  value={receiveAmount ? Number(receiveAmount).toLocaleString(undefined, { maximumFractionDigits: 8 }) : ""}
                  disabled
                />
              </div>
            </div>

            {/* Disclaimer */}
            <div className={walletStyles.swapDisclaimer}>
              Swapping may be subject to changing rates.<br />
              Values displayed are only estimates of current market price.
            </div>

            {/* Swap Button */}
            <button
              className={walletStyles.swapBtn}
              type="button"
              disabled={!swapAmount || !fromCoin || !toCoin || isLoadingQuotation || !receiveAmount}
              onClick={() => setIsSwapInitiated(true)}
            >
              {isLoadingQuotation ? "Getting Rate..." : "Swap"}
            </button>
          </form>
        ) : (
          // Confirmation Step
          <div style={{ marginTop: '20px' }}>
            <div
              onClick={() => setIsSwapInitiated(false)}
              style={{
                width: '20px',
                height: '20px',
                background: '#40196d1a',
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer'
              }}
            >
              <img src={arrow_left} alt="arrow left" />
            </div>

            <div style={{ display: "flex", justifyContent: "center", marginBottom: 24, marginTop: 20 }}>
              <img src={fromCoin?.icon} alt={fromCoin?.symbol} style={{ width: 64, height: 64, borderRadius: "50%", zIndex: 2 }} />
              <img src={toCoin?.icon} alt={toCoin?.symbol} style={{ width: 64, height: 64, borderRadius: "50%", marginLeft: -20, zIndex: 1 }} />
            </div>

            <div className={walletStyles.confirmSwapBox}>
              <p style={{ color: '#212121', fontWeight: '400', fontSize: 14, marginBottom: 0 }}>
                Please check transaction details
              </p>

              <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                <img src={fromCoin?.icon} alt={fromCoin?.name} width={24} height={24} style={{ borderRadius: '50%' }} />
                <div>
                  <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14, margin: 0 }}>Swap From</h6>
                  <p style={{ marginBottom: 0, marginTop: '5px', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                    {fromCoin?.name} Wallet
                  </p>
                </div>
              </div>

              <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                <img src={toCoin?.icon} alt={toCoin?.name} width={24} height={24} style={{ borderRadius: '50%' }} />
                <div>
                  <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14, margin: 0 }}>To</h6>
                  <p style={{ marginBottom: 0, marginTop: '5px', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                    {toCoin?.name} Wallet
                  </p>
                </div>
              </div>

              <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                <img src={moneyIcon} alt='moneyIcon' width={24} height={24} />
                <div>
                  <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14, margin: 0 }}>Swap Amount</h6>
                  <p style={{ marginBottom: 0, marginTop: '5px', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                    {swapAmount} {fromCoin?.symbol}
                  </p>
                </div>
              </div>

              <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                <img src={moneyIcon} alt='moneyIcon' width={24} height={24} />
                <div>
                  <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14, margin: 0 }}>You Receive</h6>
                  <p style={{ marginBottom: 0, marginTop: '5px', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                    {receiveAmount ? Number(receiveAmount).toLocaleString(undefined, { maximumFractionDigits: 8 }) : "0"} {toCoin?.symbol}
                  </p>
                </div>
              </div>
            </div>

            <div style={{
              background: '#f8f3ff',
              borderRadius: '12px',
              padding: '16px',
              margin: '18px 0',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              fontSize: '15px'
            }}>
              <span style={{ fontWeight: 600 }}>00:{swapTimer.toString().padStart(2, '0')}</span>
              <span style={{ fontSize: 14 }}>
                you have {swapTimer} second{swapTimer !== 1 ? "s" : ""} to continue with this market price
              </span>
            </div>

            <button
              className={walletStyles.swapBtn}
              style={{ marginTop: 24 }}
              onClick={handleFinalSwap}
            >
              Proceed
            </button>
          </div>
        )}
      </Modal>

      {/* Loading Modal */}
      <Modal canClose={false} modalOpen={isSwapLoading} setModalOpen={setIsSwapLoading}>
        <div>
          <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
            <img src={spin_circle} alt="spin circle" className={style.animate_spin} />
          </div>
          <div>
            <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>Swapping</h4>
            <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
              Please wait...
            </p>
          </div>
        </div>
      </Modal>

      {/* Success Modal */}
      <Modal canClose={true} modalOpen={isSuccessModal} setModalOpen={setSuccessModal}>
        <div>
          <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
            <img src={successIcon} alt="check mark circle" />
          </div>
          <div>
            <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>Swap Successful</h4>
            <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
              You have successfully swapped your assets.
            </p>
          </div>
          <button onClick={() => setSuccessModal(false)} style={{marginTop: '20px'}} className={style.save}>
            Continue
          </button>
        </div>
      </Modal>

      <div className={style.mainContainer}>
        <h4 className={style.welcome}>Welcome Back, {userData?.first_name}</h4>
        <div className={style.bottom}>
          <div className={style.left}>
            <WalletCard />

            <div className={style.quickActions}>
              <div className={style.qWrapper}>
                {actions &&
                  actions.map((action) => (
                    <div
                      key={action.id}
                      onClick={() => {
                        if (action.title === "More") {
                          setShowMoreDrawer(true);
                        } else if (action.title === "Buy/Sell") {
                          handleBuySellClick();
                        } else if (action.route) {
                          navigate(action.route);
                        }
                      }}
                      className={style.qAction}
                    >
                      <div className={style.qIconWrap}>{action.icon}</div>
                      <p className={style.title}>{action.title}</p>
                    </div>
                  ))}
              </div>
            </div>

            <div className={style.stats}>
              <h2>Statistics</h2>
            </div>
            <div className={style.moneyCards}>
              <div className={style.moneyCard}>
                <h2>{totalTrans > 0 ? totalTrans : 0}</h2>
                <p>Total Number of Transactions</p>
              </div>
              <div className={style.moneyCard}>
                <h2>{totalTrades > 0 ? totalTrades : 0}</h2>
                <p>Total Number of Crypto Trades</p>
              </div>
            </div>
          </div>

          <div className={style.right}>
            <div className={style.tokenSection}>
              <div className={style.tokenTabs}>
                <button
                  className={`${style.tab} ${activeTab === "all" ? style.activeTab : ""}`}
                  onClick={() => setActiveTab("all")}
                >
                  All Tokens
                </button>
                <Link to="/wallets" className={style.viewMore}>View More</Link>
              </div>
              <div className={style.tokenList}>
                {loading ? (
                  <div className={style.lottieWrap}>
                    <Lottie
                      style={{
                        width: "70px",
                        height: "70px",
                        color: "#fff",
                        padding: "0px",
                        margin: "0px",
                      }}
                      animationData={loader}
                      loop={true}
                    />
                  </div>
                ) : mappedTokens.length > 0 ? (
                  mappedTokens.slice(0,6).map((token) => (
                    <div className={style.tokenCard}
                      onClick={() => navigate(`/crypto-wallet?currency=${token.symbol}`)}
                      style={{ cursor: 'pointer' }}
                     key={token.id}>
                      <div className={style.tokenInfo}>
                        <div style={{
                          backgroundColor: '#FFFFFF',
                          width: '32px',
                          height: '32px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <img src={token.icon} alt={token.name} className={style.tokenIcon} />
                        </div>
                        <div>
                          <div className={style.tokenName}>{token.name}</div>
                          <div className={style.tokenSymbol}>{token.symbol}</div>
                        </div>
                      </div>
                      <div className={style.tokenPriceBlock}>
                        <div className={style.tokenPrice}>{token.price}</div>
                        <div
                          className={
                            token.changeUp
                              ? style.tokenChangeUp
                              : style.tokenChangeDown
                          }
                        >
                          {token.changeUp ? "↑" : "↓"} {token.change}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div style={{textAlign: "center", width: "100%"}}>No tokens found</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* More Drawer */}
      {showMoreDrawer && (
        <div className={style.moreDrawerOverlay} onClick={() => setShowMoreDrawer(false)}>
          <div className={style.moreDrawer} onClick={e => e.stopPropagation()}>
            <button className={style.closeDrawerBtn} onClick={() => setShowMoreDrawer(false)}>
              <img src={closeWhiteIcon} alt="close" style={{ width: '14px', height: '14px' }} />
            </button>
            <h2 className={style.moreDrawerTitle}>More</h2>
            <div className={style.moreDrawerHeader}>
              <img src={userData?.image_url} alt="profile" className={style.moreDrawerAvatar} />
              <div>
                <div className={style.moreDrawerGreeting}>{getGreeting()}, {userData?.first_name}</div>
                <div className={style.moreDrawerTag}>
                  AstroTag:
                  <p>{username ? username : ''}</p>
                  <img onClick={copyAstroTag} style={{cursor: 'pointer'}} src={copy_icon} alt="astroafrica.site/copy-icon.svg" />
                </div>
              </div>
            </div>
            <div className={style.moreDrawerActionsTitle}>Actions</div>
            <div className={style.moreDrawerActions}>
              {moreDrawerActions.map((action) => (
                <div
                  className={style.moreDrawerAction}
                  key={action.label}
                  onClick={() => {
                    setShowMoreDrawer(false);
                    if (action.route.startsWith('http')) {
                      window.open(action.route, '_blank');
                    } else {
                      navigate(action.route);
                    }
                  }}
                >
                  <div className={style.actionIconWrap}>{action.icon}</div>
                  <span>{action.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Main;